/**
 * .data-checkbox-at-least-one
 * Register validator for any form that has a data-validate attribute in signature
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

;(function($) {

    "use strict";

    $(function(){

        // List all possible checkboxes
        var $availableCheckboxes = $('input:checkbox[data-checkbox-at-least-one]');
        // Group by data-checkbox-group
        var $groups = _.groupBy($availableCheckboxes, function(checkbox) {
                        return $(checkbox).data('checkbox-group') || 'ungrouped';
                    });
        _.each( $groups, function( elements, group ) {
            var $elements = $(elements);
            // List all checkboxes
            var $requiredCheckboxes = $elements.filter('[required]');

            // List all checkboxes
            var $checkedCheckboxes = $elements.filter(':checked');

            // Toggle Reuqired
            var toggleRequired = function(){
                if($requiredCheckboxes.is(':checked')) {
                    $requiredCheckboxes.removeAttr('required');
                } else {
                    $requiredCheckboxes.attr('required', 'required');
                }
            };

            // if at least is checked, we can remove unchecked
            if ($checkedCheckboxes.length > 0){
                $requiredCheckboxes.not($checkedCheckboxes).removeAttr('required');
            }

            // On change
            $requiredCheckboxes.change(toggleRequired);
        });
    });

})(window.jQuery);
